import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Menu from "./views/Menu.vue";
import OurLab from "./views/Ourlab.vue";
import Gallery from "./views/Gallery.vue";
import Overview from "./views/Overview.vue";
import Process from "./views/Process.vue";
import Facility from "./views/Facility.vue";
import Engineering from "./views/Engineering.vue";
import Specialists from "./views/Specialists.vue";
import Manufacturing from "./views/Manufacturing.vue";


Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/:kioskId",
      name: "Home",
      component: Home
    },
    {
      path: "/menu/:kioskId",
      name: "Menu",
      component: Menu
    },
    {
      path: "/ourlab/:kioskId",
      name: "OurLab",
      component: OurLab
    },
    {
      path: "/gallery/:kioskId",
      name: "Gallery",
      component: Gallery
    },
    {
      path: "/overview/:kioskId",
      name: "Overview",
      component: Overview
    },
    {
      path: "/process/:kioskId",
      name: "Process",
      component: Process
    },
    {
      path: "/facility/:kioskId",
      name: "Facility",
      component: Facility
    },
    {
      path: "/engineering/:kioskId",
      name: "Engineering",
      component: Engineering
    },
    {
      path: "/specialists/:kioskId",
      name: "Specialists",
      component: Specialists
    },
{
      path: "/manufacturing/:kioskId",
      name: "Manufacturing",
      component: Manufacturing
    },
    {
      path: "/kioskid",
      name: "kioskid",
      component: () => import("./views/NotFound.vue")
    },
    // {
    //   path: "/",
    //   redirect: "/kioskid"
    // },
    {
      path: "*",
      redirect: "/kioskid"
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.name == "kioskid" || to.params.kioskId) {
    next();
  } else {
    next({ path: "/kioskid" });
  }
});

export default router;
